import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getEBLHistory, getEBLInstructionTypes } from '../actions/eBLActions';

export interface EBLDocumentHistoryDetails {
    // eblId?: any;
    id: number;
    action: string;
    actorCompany: string;
    actorUser: string | null;
    status: string;
    createdOn: string;
    actor_email: string;

}

interface EBLDocumentHistorySlice {

    isEBLDocumentHistoryLoading: boolean;
    isEBLDocumentHistoryColumnShort: boolean;
    dataLoading: boolean;
    eBLInstructionIdurl: any;
    selectedRouter: any;
    // eBLDocumentHistory: EBLDocumentHistoryDetails[];
    eBLDocumentHistory: EBLDocumentHistoryDetails[];
    showEBLDocumentHistoryColumnSettings: boolean;
    selectedEventId: number | string | null;
    eBLInstructionTypes: any;
    loadEBLInstructList: boolean

}

const initialState: EBLDocumentHistorySlice = {

    isEBLDocumentHistoryLoading: false,
    isEBLDocumentHistoryColumnShort: false,
    dataLoading: true,
    eBLInstructionIdurl: '',
    selectedRouter: '',
    eBLDocumentHistory: [],
    showEBLDocumentHistoryColumnSettings: false,
    selectedEventId: null,
    eBLInstructionTypes: [],
    loadEBLInstructList: false,

};

export const EblDocumentHistorySlice = createSlice({
    name: 'eblDocumentHistory',
    initialState,
    reducers:

    {
        updateEBLInstructionID: (state, action: PayloadAction<any>) => {
            state.eBLInstructionIdurl = action.payload;
        },
        toggleEBLDocumentHistoryLoader: (state, action: PayloadAction<boolean>) => {
            state.isEBLDocumentHistoryLoading = action.payload;
        },
        toggleEBLDocumentHistoryColumnShort: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.isEBLDocumentHistoryColumnShort = action.payload;
        },
        toggleEBLDHColumnSettings: (state, action: PayloadAction<boolean>) => {
            state.showEBLDocumentHistoryColumnSettings = action.payload;
        },
        updateSelectedEventIdDH: (
            state,
            action: PayloadAction<string | number | null>
        ) => {
            state.selectedEventId = action.payload;
        },
        // updateEBLInstructionTypes: (state, action: PayloadAction<boolean>) => {
        //     state.eBLInstructionTypes = action.payload;
        // },
        updateSelectedRoute: (state, action: PayloadAction<string>) => {
            state.selectedRouter = action.payload;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getEBLHistory.pending, (state, action) => {
            state.dataLoading = true;
        });
        builder.addCase(getEBLHistory.fulfilled, (state, action) => {
            state.dataLoading = false;
            state.eBLDocumentHistory = action.payload;
        });
        builder.addCase(getEBLInstructionTypes.pending, (state, action) => {
            state.dataLoading = true;
        });
        builder.addCase(getEBLInstructionTypes.fulfilled, (state, action) => {
            state.dataLoading = false;
            state.eBLInstructionTypes = action.payload;
        });

    }
    
});

export const {

    updateEBLInstructionID,
    toggleEBLDocumentHistoryLoader,
    toggleEBLDocumentHistoryColumnShort,
    toggleEBLDHColumnSettings,
    updateSelectedEventIdDH,
    updateSelectedRoute
    
} = EblDocumentHistorySlice.actions;

export default EblDocumentHistorySlice.reducer;
